import React, { FunctionComponent, useState } from "react";
import { styled, StyledIconButton, muiInputFormsCSS } from "@iventis/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TextField, useTheme } from "@mui/material";
import { Theme } from "@emotion/react";

interface TextDisplayAndEditorProps {
    text: string;
    minTextLength?: number;
    dataTestId?: string;
    onTextChange: (text: string) => void;
}

export const TextDisplayAndEditor: FunctionComponent<TextDisplayAndEditorProps> = ({ text, minTextLength = 1, dataTestId, onTextChange }) => {
    const theme = useTheme<Theme>();

    const [editing, setEditing] = useState(false);
    const [editableTextValue, setEditableTextValue] = useState(text);

    const handleConfirm = () => {
        onTextChange(editableTextValue);
        setEditing(false);
    };

    const handleCancel = () => {
        setEditableTextValue(text);
        setEditing(false);
    };

    const disableConfirmButton = editableTextValue?.length < minTextLength;

    return (
        <TextDisplayAndEditorContainer>
            {editing ? (
                <>
                    <TextField variant="standard" value={editableTextValue} onChange={(e) => setEditableTextValue(e.target.value)} data-testid={`${dataTestId}-input`} />
                    <StyledIconButton
                        size="small"
                        onClick={handleConfirm}
                        disabled={disableConfirmButton}
                        opacity={disableConfirmButton ? 0.5 : 1}
                        data-testid={`${dataTestId}-confirm`}
                    >
                        <FontAwesomeIcon color={disableConfirmButton ? theme.shades.two : theme.secondaryColors.confirm} icon={["far", "check"]} />
                    </StyledIconButton>
                    <StyledIconButton size="small" onClick={handleCancel}>
                        <FontAwesomeIcon color={theme.secondaryColors.cancel} icon={["far", "xmark"]} />
                    </StyledIconButton>
                </>
            ) : (
                <>
                    <div>{text}</div>
                    <StyledIconButton size="small" onClick={() => setEditing(true)} data-testid={`${dataTestId}-edit`}>
                        <FontAwesomeIcon icon={["far", "edit"]} />
                    </StyledIconButton>
                </>
            )}
        </TextDisplayAndEditorContainer>
    );
};

const TextDisplayAndEditorContainer = styled.div`
    display: flex;
    align-items: center;

    input {
        padding: 0px;
    }

    ${muiInputFormsCSS};
`;
